module.exports = __webpack_public_path__ + "static/media/BU.35e3b720.svg";